import * as angular from "angular";
import {IComponentController, ITimeoutService} from "angular";
import {QbTxnType} from "../model/QbTxnType";
import {StateService} from "@uirouter/angularjs";

class TxnViewBtnController implements IComponentController {
    private txnGuid;
    private txnType: QbTxnType

    constructor(private $state: StateService) {
    }

    $onInit(): void {
    }

    get href() {
        if(!this.txnGuid) return null;
        switch(this.txnType) {
            case QbTxnType.Invoice:
                return this.$state.href('invoice.view', {invoiceGuid: this.txnGuid});
            case QbTxnType.ReceivePayment:
                return this.$state.href('payment.view', {paymentGuid: this.txnGuid});
            default:
                return null;
        }
    }

}

export default angular.module('component.txnViewBtn', [])
    .component('txnViewBtn', {
        template: require('./TxnViewBtn.html'),
        controller: TxnViewBtnController,
        controllerAs: '$ctrl',
        bindings: {
            txnType: '=',
            txnGuid: '=',
        }
    }).name;
